import { Action } from '@ngrx/store';

export enum ToastActionTypes {
  ADD = '[SHARED TOAST] Add Toast Message',
  ADD_SUCCESS = '[SHARED TOAST] Add Toast Message Success',
  ADD_ERROR = '[SHARED TOAST] Add Toast Message Error',

  DELETE = '[SHARED TOAST] Delete Toast Message',
  DELETE_SUCCESS = '[SHARED TOAST] Delete Toast Message Success',
  DELETE_ERROR = '[SHARED TOAST] Delete Toast Message Error',
}

export class AddToast implements Action {
  readonly type = ToastActionTypes.ADD;
  constructor(public payload: any) {}
}
export class AddToastSuccess implements Action {
  readonly type = ToastActionTypes.ADD_SUCCESS;
  constructor(public payload: any) {}
}
export class AddToastError implements Action {
  readonly type = ToastActionTypes.ADD_ERROR;
  constructor(public payload: any) {}
}

export class DeleteToast implements Action {
  readonly type = ToastActionTypes.DELETE;
  constructor(public payload: any) {}
}
export class DeleteToastSuccess implements Action {
  readonly type = ToastActionTypes.DELETE_SUCCESS;
  constructor(public payload: any) {}
}
export class DeleteToastError implements Action {
  readonly type = ToastActionTypes.DELETE_ERROR;
  constructor(public payload: any) {}
}

export type ToastActions =
  | AddToast
  | AddToastSuccess
  | AddToastError
  | DeleteToast
  | DeleteToastSuccess
  | DeleteToastError;
